"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SealedChoiceSchema = exports.ChoiceSchema = exports.ChoiceValue = void 0;
const codegen_1 = require("@azure-tools/codegen");
const schema_1 = require("../schema");
const schema_type_1 = require("../schema-type");
class ChoiceValue extends codegen_1.Initializer {
    constructor(name, description, value, objectInitializer) {
        super();
        this.value = value;
        this.language = {
            default: {
                name,
                description,
            },
        };
        this.apply(objectInitializer);
    }
}
exports.ChoiceValue = ChoiceValue;
class ChoiceSchema extends schema_1.Schema {
    constructor(name, description, objectInitializer) {
        super(name, description, schema_type_1.SchemaType.Choice);
        this.apply(objectInitializer);
    }
}
exports.ChoiceSchema = ChoiceSchema;
class SealedChoiceSchema extends schema_1.Schema {
    constructor(name, description, objectInitializer) {
        super(name, description, schema_type_1.SchemaType.SealedChoice);
        this.apply(objectInitializer);
    }
}
exports.SealedChoiceSchema = SealedChoiceSchema;
//# sourceMappingURL=choice.js.map